import { useHandleAdExposureMutation } from './ad.gql.impl';

const useHandleAdExposure = () => {
  const { mutate } = useHandleAdExposureMutation();

  const sendExposureLog = (adId: string, exposedAt: number, adViewerOsPlatform: string) => {
    mutate({
      request: {
        adId,
        exposedAt,
        adViewerOsPlatform: adViewerOsPlatform,
      },
    });
  };

  return {
    sendExposureLog,
  };
};

export default useHandleAdExposure;
